import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useApolloClient } from '@apollo/react-hooks';

const PaymentListener: React.FC = () => {
    const client = useApolloClient();
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const paymentStatus = params.get('payment');

        if (paymentStatus === 'success') {
            client.writeData({
                data: {
                    snackBar: {
                        isOpen: true,
                        message: 'Paiement effectué avec succès !',
                        type: 'SUCCESS',
                        __typename: 'SnackBar',
                    },
                },
            });

            // Clean up the URL
            params.delete('payment');
            history.replace({
                search: params.toString(),
            });
        } else if (paymentStatus === 'error') {
            client.writeData({
                data: {
                    snackBar: {
                        isOpen: true,
                        message: 'Erreur lors du paiement.',
                        type: 'ERROR',
                        __typename: 'SnackBar',
                    },
                },
            });

            // Clean up the URL
            params.delete('payment');
            history.replace({
                search: params.toString(),
            });
        }
    }, [location, client, history]);

    return null;
};

export default PaymentListener;

